$(function() {
    $('#searchForm').prop('method', 'GET');
});